import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import './index.css';
import logo from '../../static/img/icon.svg';
import centerImge from '../../static/img/center-img-access.png';

function AccessDenied() {
  const location = useLocation();
  const history = useHistory();
  const [errorFromStorage, setErrorFromStorage] = useState(null);
  
  useEffect(() => {
    // Check sessionStorage for error details
    const storedError = sessionStorage.getItem('accessDeniedError');
    if (storedError) {
      try {
        setErrorFromStorage(JSON.parse(storedError));
        // Clear the error from sessionStorage after reading it
        sessionStorage.removeItem('accessDeniedError');
      } catch (e) {
        console.error('Failed to parse stored error:', e);
      }
    }
  }, []);
  
  // Get error details from location state, sessionStorage, or URL params
  const errorDetails = location.state?.error || errorFromStorage || null;
  const errorMessage = new URLSearchParams(location.search).get('message');
  
  // Default messages
  const defaultTitle = 'Access Denied';
  const defaultMessage = 'Sorry, but you don\'t have permission to access this page.\nPlease refer to system administrator.';
  
  // Use provided error details or defaults
  const title = errorDetails?.title || defaultTitle;
  const message = errorDetails?.message || errorMessage || defaultMessage;
  const suggestions = errorDetails?.suggestions || [];
  
  const handleGoBack = () => {
    // if (history.length > 1) {
    //   history.goBack();
    // } else {
      // If no history, go to dashboard
      history.push('/');
    // }
  };
  
  const handleRequestAccess = () => {
    const subject = encodeURIComponent('Request for Access Permissions');
    const body = encodeURIComponent(`Hello,\n\nI encountered an access denied error:\n\n${message}\n\nPlease help me get the necessary permissions.\n\nThank you.`);
    window.location.href = `mailto:admin@example.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className='access-page'>
      <div className='logo-area'>
        <img className='login-page-logo' src={logo} alt='logo' />
      </div>
      <div className='auto-container'>
        <div className='row'>
          <div className='col-12'>
            <div className='access-inner'>
              <div className='title-area'>
                <span className='first-block'>
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="9.37506" y1="0.25" x2="9.37506" y2="6.5" stroke="#541530" strokeWidth="1.25" />
                    <line x1="16.2776" y1="3.21025" x2="11.6727" y2="7.43599" stroke="#541530" strokeWidth="1.25" />
                    <line y1="-0.625" x2="6.25" y2="-0.625" transform="matrix(0.736793 0.676118 0.676118 -0.736793 2.50006 2.74976)" stroke="#541530" strokeWidth="1.25" />
                    <line y1="-0.625" x2="6.25" y2="-0.625" transform="matrix(0.921547 -0.388267 -0.388267 -0.921547 0.000183105 11.5)" stroke="#541530" strokeWidth="1.25" />
                    <line x1="18.0169" y1="12.076" x2="12.2572" y2="9.6493" stroke="#541530" strokeWidth="1.25" />
                    <line x1="12.1723" y1="17.7365" x2="10.3612" y2="11.7547" stroke="#541530" strokeWidth="1.25" />
                    <line y1="-0.625" x2="6.25" y2="-0.625" transform="matrix(0.504142 -0.863621 -0.863621 -0.504142 3.75 16.8975)" stroke="#541530" strokeWidth="1.25" />
                  </svg>
                </span>
                <span className='round-blox'>
                  <svg width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="5.12524" cy="4.625" r="3.75" stroke="#2E2C9A" strokeWidth="1.25" />
                  </svg>
                </span>
                <span className='two-block'>
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="9.37506" y1="0.25" x2="9.37506" y2="6.5" stroke="#541530" strokeWidth="1.25" />
                    <line x1="16.2776" y1="3.21025" x2="11.6727" y2="7.43599" stroke="#541530" strokeWidth="1.25" />
                    <line y1="-0.625" x2="6.25" y2="-0.625" transform="matrix(0.736793 0.676118 0.676118 -0.736793 2.50006 2.74976)" stroke="#541530" strokeWidth="1.25" />
                    <line y1="-0.625" x2="6.25" y2="-0.625" transform="matrix(0.921547 -0.388267 -0.388267 -0.921547 0.000183105 11.5)" stroke="#541530" strokeWidth="1.25" />
                    <line x1="18.0169" y1="12.076" x2="12.2572" y2="9.6493" stroke="#541530" strokeWidth="1.25" />
                    <line x1="12.1723" y1="17.7365" x2="10.3612" y2="11.7547" stroke="#541530" strokeWidth="1.25" />
                    <line y1="-0.625" x2="6.25" y2="-0.625" transform="matrix(0.504142 -0.863621 -0.863621 -0.504142 3.75 16.8975)" stroke="#541530" strokeWidth="1.25" />
                  </svg>
                </span>
                <div className='left-area'>
                  <svg width="174" height="208" viewBox="0 0 174 208" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_3478_6356)">
                      <path d="M101.728 116.656V72.7205C101.728 70.4152 101.796 67.9743 101.932 65.3978C102.135 62.7535 102.406 60.0076 102.745 57.1599L60.0299 116.656H101.728ZM143.223 116.656V132.522C143.223 134.014 142.715 135.302 141.698 136.387C140.748 137.404 139.392 137.912 137.63 137.912H126.137V173H101.728V137.912H40.808C39.0451 137.912 37.4178 137.37 35.9262 136.285C34.5023 135.2 33.6209 133.776 33.2819 132.014L30.3325 117.978L99.4908 25.3267H126.137V116.656H143.223Z" fill="#FBFCFF" />
                    </g>
                    <defs>
                      <filter id="filter0_d_3478_6356" x="0.332523" y="0.326663" width="172.891" height="207.673" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="5" />
                        <feGaussianBlur stdDeviation="15" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.180392 0 0 0 0 0.172549 0 0 0 0 0.603922 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3478_6356" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3478_6356" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                </div>
                <div className='center-area'>
                  <img className='login-page-logo' src={centerImge} alt='logo' />
                </div>
                <div className='right-area'>
                  <svg width="164" height="212" viewBox="0 0 164 212" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g filter="url(#filter0_d_3478_6357)">
                      <path d="M34.6979 69.0251C35.7828 61.838 37.8168 55.5324 40.8001 50.1083C43.7834 44.6841 47.5125 40.1752 51.9875 36.5817C56.4624 32.9882 61.5476 30.31 67.243 28.5471C73.0062 26.7165 79.2101 25.8011 85.8547 25.8011C92.9061 25.8011 99.2118 26.8182 104.772 28.8523C110.399 30.8185 115.145 33.5306 119.01 36.9885C122.875 40.4464 125.824 44.4807 127.858 49.0912C129.96 53.7018 131.011 58.6513 131.011 63.9399C131.011 68.6183 130.502 72.7542 129.485 76.3477C128.536 79.8734 127.078 82.9584 125.112 85.6027C123.214 88.247 120.841 90.4845 117.993 92.3152C115.213 94.1458 111.992 95.6714 108.331 96.8918C125.282 102.452 133.757 113.741 133.757 130.759C133.757 138.285 132.367 144.93 129.587 150.693C126.807 156.388 123.078 161.168 118.4 165.033C113.721 168.898 108.263 171.813 102.026 173.78C95.8555 175.678 89.3804 176.627 82.6002 176.627C75.4132 176.627 69.0737 175.814 63.5817 174.186C58.0897 172.559 53.2418 170.118 49.0381 166.864C44.9022 163.609 41.3425 159.541 38.3592 154.659C35.3759 149.71 32.7656 143.947 30.5281 137.37L42.9359 132.285C46.1904 130.929 49.2076 130.556 51.9875 131.166C54.8352 131.776 56.8693 133.268 58.0897 135.641C59.4457 138.217 60.8696 140.59 62.3612 142.76C63.9207 144.93 65.6496 146.828 67.5481 148.455C69.4466 150.015 71.5823 151.235 73.9554 152.117C76.3963 152.998 79.1762 153.439 82.2951 153.439C86.2276 153.439 89.6516 152.795 92.5671 151.507C95.4826 150.218 97.9235 148.557 99.8898 146.523C101.856 144.421 103.314 142.082 104.263 139.506C105.28 136.861 105.789 134.251 105.789 131.674C105.789 128.284 105.483 125.233 104.873 122.521C104.263 119.741 102.839 117.402 100.602 115.504C98.432 113.537 95.1775 112.046 90.8382 111.029C86.5666 109.944 80.7356 109.401 73.3452 109.401V89.6709C79.5152 89.6709 84.5665 89.1624 88.499 88.1453C92.4315 87.1283 95.5165 85.7044 97.754 83.8738C99.9915 82.0431 101.517 79.8395 102.331 77.2631C103.212 74.6866 103.653 71.8728 103.653 68.8217C103.653 62.3805 101.958 57.4648 98.5676 54.0747C95.2453 50.6846 90.4992 48.9895 84.3292 48.9895C81.6171 48.9895 79.1084 49.3963 76.8031 50.21C74.5656 50.9558 72.5316 52.0067 70.7009 53.3628C68.9381 54.7188 67.4125 56.3122 66.1243 58.1428C64.836 59.9735 63.8868 61.9736 63.2766 64.1433C61.9883 67.5334 60.3272 69.8048 58.2931 70.9575C56.259 72.0423 53.3096 72.2796 49.4449 71.6694L34.6979 69.0251Z" fill="#FBFCFF" />
                    </g>
                    <defs>
                      <filter id="filter0_d_3478_6357" x="0.52808" y="0.801029" width="163.229" height="210.826" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                        <feOffset dy="5" />
                        <feGaussianBlur stdDeviation="15" />
                        <feComposite in2="hardAlpha" operator="out" />
                        <feColorMatrix type="matrix" values="0 0 0 0 0.180392 0 0 0 0 0.172549 0 0 0 0 0.603922 0 0 0 0.25 0" />
                        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3478_6357" />
                        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_3478_6357" result="shape" />
                      </filter>
                    </defs>
                  </svg>
                </div>

                <span className='bottom-block'>
                  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="9.37506" y1="0.25" x2="9.37506" y2="6.5" stroke="#541530" strokeWidth="1.25" />
                    <line x1="16.2776" y1="3.21025" x2="11.6727" y2="7.43599" stroke="#541530" strokeWidth="1.25" />
                    <line y1="-0.625" x2="6.25" y2="-0.625" transform="matrix(0.736793 0.676118 0.676118 -0.736793 2.50006 2.74976)" stroke="#541530" strokeWidth="1.25" />
                    <line y1="-0.625" x2="6.25" y2="-0.625" transform="matrix(0.921547 -0.388267 -0.388267 -0.921547 0.000183105 11.5)" stroke="#541530" strokeWidth="1.25" />
                    <line x1="18.0169" y1="12.076" x2="12.2572" y2="9.6493" stroke="#541530" strokeWidth="1.25" />
                    <line x1="12.1723" y1="17.7365" x2="10.3612" y2="11.7547" stroke="#541530" strokeWidth="1.25" />
                    <line y1="-0.625" x2="6.25" y2="-0.625" transform="matrix(0.504142 -0.863621 -0.863621 -0.504142 3.75 16.8975)" stroke="#541530" strokeWidth="1.25" />
                  </svg>
                </span>
              </div>
              <div className='line-area'>
                <svg width="542" height="3" viewBox="0 0 542 3" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="435" y1="1.5625" x2="541.25" y2="1.5625" stroke="#2E2C9A" strokeWidth="1.875" />
                  <line y1="1.5625" x2="106.25" y2="1.5625" stroke="#2E2C9A" strokeWidth="1.875" />
                  <line x1="287.5" y1="1.5625" x2="320" y2="1.5625" stroke="#2E2C9A" strokeWidth="1.875" />
                  <line x1="182.5" y1="1.5625" x2="215" y2="1.5625" stroke="#2E2C9A" strokeWidth="1.875" />
                </svg>
              </div>
              <div className='content-area'>
                <h3>{title}</h3>
                <div className='error-message'>
                  <p style={{ whiteSpace: 'pre-line' }}>{message}</p>
                  {suggestions.length > 0 && (
                    <div className='suggestions'>
                      <h4>What you can do:</h4>
                      <ul>
                        {suggestions.map((suggestion, index) => (
                          <li key={index}>{suggestion}</li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
                <div className='action-buttons'>
                  <button className='btn-style-border' onClick={handleGoBack}>
                    <i className='icon'>
                      <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.17542 5.67547C0.858114 5.99278 0.858114 6.50722 1.17541 6.82452L6.34613 11.9952C6.66343 12.3125 7.17788 12.3125 7.49518 11.9952C7.81248 11.6779 7.81248 11.1635 7.49518 10.8462L2.89899 6.25L7.49518 1.65381C7.81248 1.33651 7.81248 0.822059 7.49518 0.504758C7.17788 0.187456 6.66343 0.187456 6.34613 0.504758L1.17542 5.67547ZM14.2499 6.25L14.2499 5.4375L1.74994 5.4375L1.74994 6.25L1.74994 7.0625L14.2499 7.0625L14.2499 6.25Z" fill="#2E2C9A" />
                      </svg>
                    </i>
                    Go Back
                  </button>
                  {/* <button className='btn-style-solid' onClick={handleRequestAccess}>
                    <i className='icon'>
                      <svg width="15" height="13" viewBox="0 0 15 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 6.5L13 6.5M13 6.5L8 1.5M13 6.5L8 11.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </i>
                    Request Access
                  </button> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AccessDenied;